var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPetProfileLinks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user_account_links") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.44,
    width: 600,
    height: 600,
    fill: "none",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "user_account_links"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300.44,
    r: 299.69,
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("g", {
    id: "links"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.53,228.77a100.18,100.18,0,0,1,90.56-2.22l49.74-49.74a37.1,37.1,0,0,1,52.46,52.47L373.67,278.9,353,299.62a37.07,37.07,0,0,1-52.28.17l-.18-.18a37.1,37.1,0,0,0-52.29.18L229,319a99.69,99.69,0,0,0,19.3,27.12l5.69,5.68a99.88,99.88,0,0,0,141.39,0L477,270.19a100,100,0,0,0,0-141.39l-5.68-5.68a100,100,0,0,0-141.39,0l-81.65,81.64A100,100,0,0,0,230.53,228.77Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.65,469.13l5.69,5.68a100,100,0,0,0,141.38,0l81.65-81.64a99.7,99.7,0,0,0,17.74-24,100.12,100.12,0,0,1-90.55,2.21L230.33,422.6a37.1,37.1,0,0,1-52.47-52.47L229,319l19.23-19.24a37.1,37.1,0,0,1,52.29-.18l.18.18a37.07,37.07,0,0,0,52.28-.17l20.72-20.72a99.63,99.63,0,0,0-19.3-27.12l-5.69-5.69a99.86,99.86,0,0,0-141.38,0l-81.65,81.64A100,100,0,0,0,125.65,469.13Z",
    fill: "#bfebff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetProfileLinks);
export default __webpack_public_path__ + "static/media/pet_profile_links.46632dac8b2c37c34d37a24c155746cb.svg";
export { ForwardRef as ReactComponent };